export const NavClick = ({ label, selected, onClick }) => (
  <button
    className={`flex items-center px-4 py-2 focus:outline-none ${selected ? 'border-b-4 border-blue-500' : 'border-b-2 border-transparent'} hover:border-gray-300`}
    onClick={onClick}
  >
    {/* <div className={`${selected ? 'text-blue-500' : ''}`}>{icon}</div> */}
    <span className={`ml-2 ${selected ? 'font-bold' : 'text-gray-800'}`}>{label}</span>
  </button>
);
